import { computed, ref, watch } from 'vue';
import { IRouter } from '@/models/router/router.interface';
import { DashboardAccessItem } from '@/models/dashboard-data.interface';
import { defaultSizeConfiguration } from '@/static/dashboard-size-configurations';
import store from '@/store';

export default class EmbeddedDashboardCode {
	// A plain ref, latched to the first non-empty token: the fetch loop may still be
	// in flight when this is constructed (e.g. a deep link straight into this component),
	// so a one-time read at construction time can permanently capture an empty JWT.
	// Latching (rather than staying reactive to every refresh) still avoids the
	// dashboard re-rendering on each periodic token refresh.
	private latchedTableauJWT = ref('');

	constructor() {
		watch(this.tableauJWTFromStore, (jwt) => {
			if (jwt && !this.latchedTableauJWT.value) {
				this.latchedTableauJWT.value = jwt;
			}
		}, { immediate: true });
	}

	public tableauJWT = computed((): string => this.latchedTableauJWT.value);

	public dashboardUrl = computed((): string => {
		const relevantDashboard = this.availableDashboards.value.find((dashboard => dashboard.id === this.dashboardId.value));
		const url = relevantDashboard ? relevantDashboard.url : '';
		return `${url}?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link`;
	});

	public dashboardWidth = computed((): number => {
		return defaultSizeConfiguration.width;
	});

	public dashboardHeight = computed((): number => {
		return defaultSizeConfiguration.height;
	});

	public dashboardId = computed((): string => {
		return this.router.value.props.id;
	});

	private tableauJWTFromStore = computed((): string => {
		return store.getters.tableauJWT();
	});

	private availableDashboards = computed((): DashboardAccessItem[] => {
		return store.getters.availableDashboards();
	});

	private router = computed((): IRouter => {
		return store.getters.router();
	});
}
